import { render, staticRenderFns } from "./PagePaymentError.vue?vue&type=template&id=6ddc96c5"
import script from "./PagePaymentError.vue?vue&type=script&lang=js"
export * from "./PagePaymentError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports